import { Component, Input, Output, EventEmitter } from '@angular/core';
import { warningTextsObject } from '../../constants-types/constants';

@Component({
    selector: 'warning-tooltip',
    template: `
        <div class="bottom tooltip fade in toggler-warning">
            <div class="tooltip-arrow"></div>
            <dialog
                class="toggler-dialog"
                data-testing="test-auto-select-objective-confirmation-dialog"
            >
                <div class="toggler-dialogBody">
                    <div class="toggler-warning-text">
                        {{ warningTextsObject.warningText }}
                    </div>
                </div>
                <div class="toggler-dialogFooter">
                    <button
                        type="button"
                        class="button button-transparent button-sm button-dialog-cancel"
                        (click)="clickedCancel.emit()"
                        data-testing="button-dialog-cancel"
                    >
                        {{ warningTextsObject.leftButtonText }}
                    </button>

                    <button
                        type="button"
                        class="button button-white button-sm button-dialog-proceed"
                        (click)="clickedProceed.emit()"
                        data-testing="button-dialog-proceed"
                    >
                        {{ warningTextsObject.rightButtonText }}
                    </button>
                </div>
            </dialog>
        </div>
    `,
    standalone: false
})
export class WarningTooltipComponent {
    @Input()
    warningTextsObject: warningTextsObject;

    @Output()
    clickedProceed = new EventEmitter<void>();
    @Output()
    clickedCancel = new EventEmitter<void>();
}
